enum LocalStorageKeyEnum {
  JwtToken = 'jwtToken',
  RefreshToken = 'refreshToken',
  LastActivityTS = 'lastActivityTS',
}

export default LocalStorageKeyEnum;
